<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { Collapsible } from "@/components/ui/collapsible";
import { cn } from "@/lib/utils";

const props = defineProps<{
  class?: HTMLAttributes["class"];
}>();
</script>

<template>
  <Collapsible
    :class="cn('not-prose mb-1 w-full rounded-md border border-border', props.class)"
    v-bind="$attrs"
  >
    <slot />
  </Collapsible>
</template>
